/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileReference,
    MediaFileReferenceFromJSON,
    MediaFileReferenceFromJSONTyped,
    MediaFileReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileTemplate
 */
export interface MediaFileTemplate {
    /**
     * 
     * @type {number}
     * @memberof MediaFileTemplate
     */
    id: number;
    /**
     * 
     * @type {MediaFileReference}
     * @memberof MediaFileTemplate
     */
    file: MediaFileReference;
    /**
     * 
     * @type {string}
     * @memberof MediaFileTemplate
     */
    name: string;
}

export function MediaFileTemplateFromJSON(json: any): MediaFileTemplate {
    return MediaFileTemplateFromJSONTyped(json, false);
}

export function MediaFileTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'file': MediaFileReferenceFromJSON(json['file']),
        'name': json['name'],
    };
}

export function MediaFileTemplateToJSON(value?: MediaFileTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file': MediaFileReferenceToJSON(value.file),
        'name': value.name,
    };
}


